import { vars } from '../styles/theme.css';
import { text } from '../styles/text.css';

/**
 * Home-page footer: privacy note, clear-local-data button, copyright.
 *
 * The clear-data button removes every localStorage key the app writes to
 * (voice prefs, display prefs, theme, progress). After clearing, a reload
 * snaps every component back to its default state.
 */

const STORAGE_KEYS = ['voices', 'displayPrefs', 'theme', 'progress'] as const;

const CLEAR_PROMPT =
  'Clear all local data? This resets your voice picks, theme, furigana/gloss settings, and lesson progress on this device. Audio cache in your browser is not affected.';

function clearLocalData() {
  if (!window.confirm(CLEAR_PROMPT)) return;
  for (const key of STORAGE_KEYS) localStorage.removeItem(key);
  window.location.reload();
}

export function Footer() {
  return (
    <footer
      className="mt-10 pt-6 pb-4 text-center"
      style={{
        borderTop: `1px solid ${vars.color.border}`,
      }}
    >
      <p
        className={text.caption}
        style={{ color: vars.color.inkMuted, maxWidth: 320, margin: '0 auto' }}
      >
        Everything stays on this device — no accounts, no servers, no tracking.
      </p>
      <button
        type="button"
        onClick={clearLocalData}
        className={`mt-3 ${text.caption}`}
        style={{
          color: vars.color.inkSoft,
          textDecoration: 'underline',
          textDecorationStyle: 'dotted',
          textDecorationColor: vars.color.inkFaint,
          textUnderlineOffset: '3px',
          background: 'none',
          border: 'none',
          padding: '4px 8px',
          cursor: 'pointer',
        }}
      >
        Clear local data
      </button>
      <p
        className={text.tag}
        style={{
          color: vars.color.inkFaint,
          letterSpacing: '0.04em',
          marginTop: 14,
        }}
      >
        © 2026 AiongTaigi
      </p>
    </footer>
  );
}
